<template>
    <div class="t-work-area__row">
        <div class="t-work-area__column_big t-documents">
            <div class="t-work-area__cell" v-if="upload_files.length">
                <h2>{{ pageText.activeLoad }} <span>{{ pageText.stack }} {{ this.upload_files.length }} {{ upload_count }}</span>
                </h2>
                <div class="t-documents__upload">
                    <cmp-doc-upload v-for="(doc, index) in upload_files"
                                    :key="'doc_upload_' + index"
                                    :data="doc"
                                    @cancelUpload="CancelUpload(index)"></cmp-doc-upload>
                </div>
            </div>

            <div class="t-work-area__cell">
                <form class="t-documents-load">
                    <label class="t-btn t-btn_full t-btn_file"><input type="file" multiple
                                                                      @change="LoadFile($event.target.files)"><span>{{ pageText.loadBtn }}</span></label>
                </form>
                <h2>{{ documents._meta.totalCount }} {{ doc_count }}</h2>

                <div class="t-document-list">
                    <cmp-doc v-for="(doc, index) in documents.items" :key="'doc_' + index" :data="doc"></cmp-doc>
                </div>

                <cmp-pagination v-if="documents._meta.pageCount > 1"
                                :pages="documents._meta.pageCount"></cmp-pagination>
            </div>
        </div>
        <div class="t-work-area__column_small _min">
        </div>
    </div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/docPage.json' : 'staticText',
        main: {
            activeLoad: "Активные загрузки",
            stack: "В очереди",
            loadBtn: "Загрузить файлы"
        }
    };

    import {store} from '../../store'

    import {mapActions, mapGetters} from 'vuex';

    import Pagination from '../../vue_components/Pagination.vue'
    import Doc from '../../vue_components/Doc.vue'
    import DocUpload from '../../vue_components/DocUpload.vue'

    export default {
        data() {
            return {
                upload_files: [],
                pageText: {}
            }
        },
        components: {
            'cmp-pagination': Pagination,
            'cmp-doc': Doc,
            'cmp-doc-upload': DocUpload
        },
        computed: {
            ...mapGetters('staticText', ['fileArr']),
            ...mapGetters('profile', ['documents']),
            doc_count() {
                return this.declOfNum(this.documents._meta.totalCount, this.fileArr)
            },
            upload_count() {
                return this.declOfNum(this.upload_files.length, this.fileArr)
            }
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            ...mapActions('profile', ['LoadDocuments']),
            LoadFile(files) {
                let _this = this;
                for (let i = 0; i < files.length; i++) {
                    let type = files[i].name.split('.')[1].replace('.', '') + ', ' + Math.floor(files[i].size / 1000) + ' КБ';

                    this.upload_files.push({
                        file: files[i],
                        name: files[i].name.split('.')[0],
                        type: type,
                        progress: 0,
                        error: false
                    });

                    let fd = new FormData();
                    fd.append('file', files[i]);

                    _this.$http.post('upload_doc', fd, {
                        progress(e) {
                            if (e.lengthComputable) {
                                _this.upload_files[i].progress = (e.loaded / e.total) * 100;
                            }
                        }
                    })
                        .then(response => response.json())
                        .then(data => {
                            if (data.success) {
                                this.LoadDocuments(this.$route.query.page);
                                this.upload_files = [];
                            }
                        })
                        .catch(error => {
                            _this.upload_files[i].error = true;
                        })
                }
            },
            declOfNum(n, titles) {
                return titles[(n % 10 === 1 && n % 100 !== 11) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2]
            },
            CancelUpload(index) {
                if (this.upload_files[index].error)
                    this.upload_files.splice(index, 1)
            },
            Load(pageText) {
                this.pageText = pageText;
                // setTimeout(() => {
                //     this.UpdatePreloadState(false);
                // }, 500)
            }
        },
        beforeRouteLeave(to, from, next) {
            // this.UpdatePreloadState(true);
            next();
        },
        beforeRouteUpdate(to, from, next) {
            store.dispatch('profile/LoadDocuments', {page: to.query.page}).then(() => {
                next()
            });
        },
        beforeRouteEnter(to, from, next) {
            let count = 0;
            let pageText = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;

                count++;
                RunNext();
            });
            store.dispatch('profile/LoadDocuments', {page: 1}).then(() => {
                count++;
                RunNext();
            });
            let RunNext = () => {
                if (count > 1)
                    next(vm => vm.Load(pageText))
            }
        }
    }
</script>

<style lang="sass">
    .t-documents
        h2
            color: $blue
            margin: 0 0 42px
            span
                display: block
                font-size: 16px
                margin-top: 16px
        .t-documents-load
            width: 186px
            margin: 0 0 32px

        .t-document-list
            margin: 0 0 50px
</style>


// WEBPACK FOOTER //
// src/vue_pages/Profile/Documents.vue